// extracted by mini-css-extract-plugin
export default {"reset-password-container":"ResetPassword_reset-password-container__MJVB6","amplify":"ResetPassword_amplify__OmBar"};